import { css } from 'styled-components';
import { colors } from '~/themes/variables';
const styles = css `
  overflow: hidden;
  transition: max-height 1s ease;
  .collapsed {
    max-height: 60px;
  }
  .expanded {
    max-height: 300px;
  }
  .read-more-less-button {
    color: ${colors.purpleButton};
    cursor: pointer;
    margin-left: 6px;
    font-style: normal;
    text-decoration: underline;
  }
`;
export default styles;
